// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Callsheets_Container__ukv-Z {
    min-height: 100px;
}

.Callsheets_SubTitleSpan__nHF1X {
  background-color: #c1f1f7;
  font-weight: 700;
  /* font-size: 1.5rem; */
}

.Callsheets_Break5__tYV0s {
  border-top: 4px solid #c1f1f7;
}

.Callsheets_BreakTitle__zoSqI {
  border-top: 10px solid #e8f0f1;
}

.Callsheets_Walk1__iZdce {
  color: #000;
  font-weight: 700;
}

.Callsheets_Walk2__yNZgy {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 700;
}

.Callsheets_SubTitle__BB2uj {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Callsheets_SubTitleC__qMd7Z {
  background-color: #39606e;
  background-color: #e8f0f1;
  /* background-color: #00d1ff; */
  font-weight: 700;
  /* color: #fff; */
}

.Callsheets_UsersInfo__O1rXx {
  color: #1da3aa;
}

.Callsheets_Ital__eUzSj {
  font-style: italic;
}

.Callsheets_ManTitle__K6Aqm {
 color: #038dac;
 font-weight: 700;
}

.Callsheets_AddCrew__c5MNV {
  color: #000;
}

.Callsheets_Small__ZWuZz {
  font-size: .75rem;
  font-style: italic;
}

.Callsheets_SmallInfo__XiCw0 {
  font-size: .75rem;
  color: #1da3aa;
  color: #0c414f;
  cursor: pointer;
}

.Callsheets_SmallSize__FzpMg {
  font-size: .75rem;
  color: #1da3aa;
}

.Callsheets_SmallSizeBold__iX30k {
  font-size: .85rem;
  font-weight: 700;
}

.Callsheets_SmallCrew__PLa5W {
  font-size: .85rem;
  font-weight: 700;
  color: #0c414f;
  color: #0c5d73;
}

.Callsheets_Role__Rp82f {
  color: #686c8a;
  color: #525463;
  color: #494d70;
}

.Callsheets_CountryBack__yX\\+Yz {
  background-color: #32c0e4;
  color: #fff;
}

.Callsheets_BorderYour__HXjS0 {
  background-color: #f7e7f6;
}

.Callsheets_BorderbbbYour__tKDO8 {
  background-color: rgb(223 254 240);
}

.Callsheets_YourCallMed__1vAza {
  font-weight: 700;
  color: #780770;
  /* font-family: Playfair; */
  /* font-size: 2.5rem; */
  color: #076f78;
  color: #000;
}

.Callsheets_YourCallMob__MxlgX {
  /* background-color: #c1f1f7; */
  color: #780770;
  font-weight: 700;
  font-size: 1.25rem;
  color: #076f78;
  color: #000;
}

.Callsheets_YourCallMobUser__IXWrj {
  background-color: #c1f1f7;
  color: #000;
  font-size: 1rem;
  color: #076f78;
}

.Callsheets_UnitCallMed__FwDJO {
  font-size: 1.5rem;
  font-weight: 700;
  color: #076f78;
}

.Callsheets_UnitCallMob__ErYpV {
  color: #076f78;
  font-weight: 700;
  font-size: 1rem;
}

.Callsheets_UnitCallMedDate__yF1Td {
  background-color: #e9fffd;
  font-style: italic;
  color: #000;
  font-size: 1.25rem;
}

.Callsheets_UnitCallMedDate2__v\\+FBW {
  /* background-color: #e9fffd; */
  font-style: italic;
  color: #780770;
  font-size: 1.5rem;
}

.Callsheets_UnitCallMobDate__Tl-v7 {
  background-color: #e9fffd;
  font-style: italic;
  color: #000;
  font-size: 1rem;
}

.Callsheets_UnitCallMedDay__mswjn {
  background-color: #f6fffe;
  color: #000;
  font-size: 1.25rem;
}

.Callsheets_UnitCallMobDay__tZskQ {
  background-color: #f6fffe;
  color: #000;
  font-size: 1rem;
}

.Callsheets_CharactersTitle__Fg\\+rw {
  color: rgb(40, 189, 189);
  color: rgba(89, 70, 14, 0.99);
  font-weight: 600;
}

.Callsheets_Div30div__a8muN {
    height: 30px;
    overflow: hidden;
  }

  .Callsheets_Div30div2__P4RB- {
    overflow: hidden;
  }

  .Callsheets_Div30A__EyG6z {
    color: #666;
    font-weight: 400;
  }

  .Callsheets_Div30M__qpOjs {
    color: #333;
    font-weight: 700;
    /* font-size: .75rem !important; */
  }

.Callsheets_BorderRight__z9\\+Th {
  border-right: 1px solid #c1f1f7;
}

.Callsheets_Hig20__774NH {
  min-height: 20px;
}

.Callsheets_Break__MaUdb {
  border-top: 10px solid #d0d9db;
}

.Callsheets_BreakBlack__-xzG- {
  border-top: 5px solid #000;
}

.Callsheets_BottomScene__FLTk5 {
  border-bottom: 3px solid #708386;
}

.Callsheets_Red__yKFeJ {
  color: #00d1ff;
}

.Callsheets_Red2__xfBJL {
  color: red;
}

.Callsheets_SubTitle6__EbztF {
    background-color: #010f13;
    color: #fff;
    font-size: 1.25rem;
    /* font-family: "Noto Serif"; */
}

.Callsheets_Border2__Wmkl7 i {
  color: #000;
}

.Callsheets_EditXcrew__YEtKW {
  background-color: #fff;
  border: 1px solid rgba(226, 200, 123, 0.99);
}

.Callsheets_SubTitle11__bXUuS {
  background-color: #fff;
  font-weight: 700;
  color: #000;
  border: 3px solid red;
}

.Callsheets_White__BaLoQ {
  background-color: #fff;
}

.Callsheets_WhiteEdit__be7bC {
  background-color: #fff;
  border: 2px solid #c1f1f7;
}

.Callsheets_WhiteForm__bBrok {
  background-color: #fff;
  border-left: 1px solid rgba(129, 102, 21, 0.99);
  border-right: 1px solid rgba(129, 102, 21, 0.99);
  border-bottom: 1px solid rgba(129, 102, 21, 0.99);
  border-top: 1px solid rgba(129, 102, 21, 0.99);
}

.Callsheets_Break7__PRssg {
  border-top: 3px solid #c1f1f7;
}

.Callsheets_RightPanel__g4Mr4 {
 border-right: 1px solid #c1f1f7;
 border-left: 1px solid #c1f1f7;
}

.Callsheets_CastCall__\\+ZLY0 {
  border-top: 3px solid #c1f1f7;
  border-bottom: 3px solid #c1f1f7;
  border-left: 3px solid #c1f1f7;
  border-right: 3px solid #c1f1f7;
}
/* .CastCall {
  border-top: 2px solid #c1f1f7;
  border-bottom: 2px solid #c1f1f7;
  border-left: 2px solid #c1f1f7;
  border-right: 2px solid #c1f1f7;
} */

.Callsheets_HrSched__v9\\+el {
  border-top: 2px solid #fff;
}

.Callsheets_Info__tNKN2 {
  font-size: .75rem !important;
  font-weight: 700;
  /* color: rgb(170, 27, 55); */
  color: rgb(183, 44, 72);
  cursor: pointer;
  font-style: italic;
}

.Callsheets_Info__tNKN2:hover {
  color: rgb(107, 10, 29);;
}

.Callsheets_SelectBox__BAlUd {
  border: 1px solid #c1f1f7;
}

.Callsheets_BoldSceneS__pCQSs {
  border-bottom: #1ea7ae;
  width: 80%;
}

.Callsheets_HRWide__9PBtK {
  border-top: 3px solid #c1f1f7;
}

.Callsheets_HRWider__\\+Gp8D {
  border-top: 10px solid #e8f0f1;
}

.Callsheets_HRGold2__v0Gn6 {
  border-top: 1px solid rgba(226, 200, 123, 0.99);
  border-top: 1px solid #00d1ff;
}

.Callsheets_HRGold__Sh\\+no {
  border-bottom: 1px solid rgba(226, 200, 123, 0.99);
  min-height: 20px;
}

.Callsheets_Borderl__mMXk7 {
  padding-bottom: 5px;
}

.Callsheets_BreakCrew__BWXoB {
  border-top : 2px solid #c1f1f7;
}

/* .Border {
  border-top: 2px solid #e8f0f1;
  border-bottom: 2px solid #e8f0f1;
  border-left: 2px solid #e8f0f1;
  border-right: 2px solid #e8f0f1;
} */

.Callsheets_Border__tKCn7 {
  border-top: 3px solid #c1f1f7;
  border-bottom: 3px solid #c1f1f7;
  border-left: 3px solid #c1f1f7;
  border-right: 3px solid #c1f1f7;
}

.Callsheets_BorderLoc__DPX0c {
  border-top: 1px solid #c1f1f7;
  border-bottom: 1px solid #c1f1f7;
  border-left: 1px solid #c1f1f7;
  border-right: 1px solid #c1f1f7;
}

.Callsheets_Border2__Wmkl7 {
  border-top: 1px solid #c1f1f7;
  border-bottom: 1px solid #c1f1f7;
  border-left: 1px solid #c1f1f7;
  border-right: 1px solid #c1f1f7;
  min-height: 34px;
}

.Callsheets_Border3__c4i1O {
  border-bottom: 1px solid #c1f1f7;
}

.Callsheets_White1__6VR1t {
  border: 1px solid #999;
}

  .Callsheets_Width__LMySo {
    width: 70%;
  }
  
  .Callsheets_Width2__dnvIB {
    width: 80%;
  }
  
  .Callsheets_Width3__w2HdB {
    width: 80%;
  }
  
  .Callsheets_Width95__y\\+5K3 {
    width: 95%;
  }

p {
  margin-bottom: 0;
}

.Callsheets_SubTitleBlack__Wihw4{
  background-color: #000;
  color: #fff;
  font-weight: 700;
}

.Callsheets_Break4__6OU7H {
  border-top: 5px solid #b1b5b6;
}

.Callsheets_SubTitle2__q\\+6mW {
  background-color: #d6fcff;;
  font-weight: 700;
  width: 40%;
  color: rgba(129, 102, 21, 0.99);
  color: #000
}

.Callsheets_SubTitle2__q\\+6mW p {
  color: #fff;
} 

.Callsheets_SubTitle3__YAH9U {
  background-color: #e4f2f4;
  font-weight: 700;
  width: 20%;
}

.Callsheets_SubTitle4__Gqcdd {
  background-color: #e4f2f4;
  font-weight: 700;
  width: 60%;
}

.Callsheets_SubTitle7__x6Kli {
  background-color: #e4f2f4;
  font-weight: 700;
}

.Callsheets_BoldScene__c2Xij {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.Callsheets_BoldScene2__MhZqN {
  color: rgba(129, 102, 21, 0.99);
}

.Callsheets_CrewInfoP__XMxjk {
  font-weight: 700;
  margin-bottom: 3px;
  color: #616370;
  color: #494d70;
}

.Callsheets_CrewInfop__Lp1Ha {
  margin-bottom: 3px;
  color: #616370;
  color: #494d70;
}

.Callsheets_CrewInfop__Lp1Ha i {
  margin-bottom: 3px;
  color: #616370;
  color: #494d70;
}

.Callsheets_Icon__ELQb\\+ i {
  color: #000;
}

.Callsheets_BoldTitleCall__l\\+GYS {
  font-weight: 700;
  color: #F5F5F5;
  background-color: #000;
}

.Callsheets_Break__MaUdb {
  border-top: 10px solid #d0d9db;
}

.Callsheets_Break1__QbNzP {
  border-top: 1px solid #d0d9db;
  /* border-top: 1px solid rgb(140, 111, 25, 99%); */
}

.Callsheets_Break2__WBt5x {
  border-top: 5px solid #d0d9db;
}

/* CallsheetTop */
.Callsheets_BoldBase__J23K9 {
  color: #1ea7ae;
}

.Callsheets_Top__PyKCF {
  background-color: #1ea7ae;
  border: 3px solid #1ea7ae;
  color: #fff;
}

.Callsheets_Top__PyKCF:hover {
  background-color: #27c6cf;
  color: #fff;
}

.Callsheets_Inner__nniYk {
  background-color: #fafafa;
  color: #000;
}

.Callsheets_Top__PyKCF:hover .Callsheets_Inner__nniYk {
  background-color: #27c6cf;
  color: fff;
}

.Callsheets_Map__P9aTA {
  cursor: pointer;
}

.Callsheets_BodyColor__BOS6f {
  background-color: #f8f8f8;
  height: 40px;
}

.Callsheets_WhiteAqua__KQeEo {
  background-color: #f6fffe;
}

.Callsheets_WhiteAquaPro__wDcQB {
  background-color: #f6fffe;
  font-family: Playball;
}

.Callsheets_WhiteAquaAdd__1aV5P {
  background-color: #f6fffe;
  font-family: Playfair;
}

.Callsheets_WhiteAquaAdd2__pHaX6 {
  background-color: #f6fffe;
  font-family: Playfair;
}
.Callsheets_WhiteAquaAdd3__12wNw {
  background-color: #f6fffe;
  font-family: Parisienne;
}
.Callsheets_WhiteAquaAdd4__GMNSz {
  background-color: #f6fffe;
  font-family: Parisienne;
}

.Callsheets_Close__iMoch {
  color: rgb(28, 131, 131);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.Callsheets_Close__iMoch:hover {
  color: rgb(60, 237, 237);
  cursor: pointer;
}

#Callsheets_dropdown-basic-button__XWdxb {
  padding: 0.1rem 0.1rem;
  color: #000;
  background-color: #27c6cf;
}

.Callsheets_dropdown-menu__vmrS- {
  overflow-y: scroll;
}

#Callsheets_dropdown-basic-button__XWdxb {
  padding: 0.01rem 0.01rem !important;
  color: #000;
  background-color: #27c6cf;
}

.Callsheets_dropdown-menu__vmrS- {
  display: block;
  overflow-y: scroll !important
}

.Callsheets_DropButt__zfEWp {
  /* z-index: 999;
  color: #000; */
  overflow-y: scroll;
  height: 300px;
}

.Callsheets_dropdown-toggle__c6Kks.Callsheets_btn__NE8wM.Callsheets_btn-primary__HoX9F {
  color: #000
}

.Callsheets_CloseIns__iiNS3 {
  color: red;
}

.Callsheets_Back__B6sSU {
  background-color: rgb(242, 247, 252);
}

.Callsheets_Back2__ypRTo {
  background-color: #ffffff;
}

.Callsheets_Back3__RKwvq {
  background-color: rgb(241 248 253);
}

.Callsheets_Crew__YrTRi {
  min-height: 50px;
}

.Callsheets_White__BaLoQ {
  background-color: #fff;
}

.Callsheets_CallLogoDiv__CpUjk {
  height: 80px;
  border: 2px solid #456989;
}

.Callsheets_CallLogoDivMob__2npdA {
  height: 60px;
  border: 2px solid #456989;
}

.Callsheets_UnitCall__7l8Z0 {
  background-color: #c1f1f7;
  color: #000;
}

.Callsheets_MovieName__1tijB {
  /* color: #00d1ff;
  color: #780770; */
  color: #000; 
  font-size: 2.5rem;
  background-color: #f6fffe;
  font-family: Playball;
  /* padding-left: 120px;
  padding-right: 120px; */
  padding-top: 0px;
  margin-top: 0px;
}

.Callsheets_MovieNameMo__xGt2j {
  color: #00d1ff;
  color: #780770;
  color: #000;
  font-size: 1.75rem;
  background-color: #f6fffe;
  font-family: Playball;
}

.Callsheets_LogoEdit__3Gh6B {
  height: 1px;
  max-width: 100%;
  object-fit: contain;
}

.Callsheets_Logo__1WmoB {
  height: 100px;
  max-width: 100%;
  object-fit: contain;
}

.Callsheets_LogoMo__2FAqW {
  height: 50px;
  max-width: 100%;
  object-fit: contain;
}

.Callsheets_BoldU__Ylogb {
  color: #780770;
  font-weight: 700;
}

.Callsheets_BoldV__RWZDZ {
  color: #076f78;
  font-weight: 700;
}

.Callsheets_BoldA__Ss\\+W5 {
  color: #076f78;
  font-weight: 700;
}

.Callsheets_WhiteAquaProU__BRoNH {
  background-color: #f6fffe;
  font-family: Playball;
  color: #076f78;
}

.Callsheets_Titles__dEGbn {
  background-color: #dbf2f5;
  color: #000;
}

.Callsheets_CrewInfoRow__m2T-x {
  /* border-bottom: 5px solid #fff; */
  /* border-top: 5px solid #fff; */
  margin-top: 10px;
  margin-bottom: 5px;
}

.Callsheets_CrewInfoRowAdd__fBkFW {
  border-bottom: 1px solid #fff;
}

/* .Button {
  color: #185f70;
  font-weight: 700;
  cursor: pointer;
} */

.Callsheets_Button__qVsj3 {
  color: #013441;
  font-weight: 700;
  cursor: pointer;
}

.Callsheets_Button__qVsj3:hover {
  color: #04809f;
  font-weight: 700;
}

.Callsheets_AcknowledgeButton__J\\+ESN {
  min-width: 9rem;
  width: auto;
  padding-left: 16px;
  padding-right: 16px;
  white-space: nowrap;
}

.Callsheets_Important__mk7pa {
  background-color: antiquewhite;
}

.Callsheets_ImportantText__830I2 {
  color: #000;
}

.Callsheets_CastEntered__pX8Wj {
  background-color: #dde7ef;
  background-color: #f1f5f7;
  background-color: #ecfbfd;
  min-height: 40px;
}

.Callsheets_Bold__-j0xc { 
  font-weight: 700;
}

.Callsheets_Title__tudB\\+ {
  background-color: #fff;
}

.Callsheets_Input__mlVQP {
  background: #ffffff;
  /* border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  text-align: center;
  height: 30px !important;
}

.Callsheets_InputB__XOf4R {
  background: #ffffff;
  /* border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  height: 30px !important;
}

.Callsheets_InputScene__gSA\\+0 {
  background: #ffffff;
  /* border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  color: #525463;
  padding: 0px 10px;
  min-height: 30px !important;
  text-align: center;
 }

.Callsheets_TitleBox__w5RwR {
  background-color: #e8f0f1;
  color: #333;
}

.Callsheets_TitleBoxB__-18ag {
  font-weight: 700;
}

.Callsheets_TitleBox2__aVf9C {
  border-right : 2px solid #fff;
  color: #000;
}

/* .Border2 {
  border: 2px solid #e8f0f1;
} */

/* .Borderl {
  border-bottom: 2px solid #e8f0f1;
  border-left: 2px solid #e8f0f1;
  border-right: 2px solid #e8f0f1;
}

.Borderm {
  border-bottom: 2px solid #e8f0f1;
  border-left: 2px solid #e8f0f1;
  border-right: 2px solid #e8f0f1;
} */

.Callsheets_HSpan__oRPOR {
  font-size: .75rem;
  font-weight: 700;
}

.Callsheets_FormBox__6evPI {
  background-color: aliceblue;
  font-weight: 700;
}

.Callsheets_ScenesBox__3y\\+0l {
  background-color: #eaf2fa;
}

.Callsheets_NextCall__tSkbc {
  background-color: #fffff5; 
  color: #000;
}

.Callsheets_Drop__B9MIS i {
  color: #000;
}

/* info */

.Callsheets_SceneBox__aRZIv {
  border: 1px solid #fafafa;
  background-color: #fff;
  font-weight: 700;
}

.Callsheets_BoldTitle__dTrtj {
  font-weight: 700;
  background-color: rgb(209, 240, 240);
}

.Callsheets_Image__BkUc3 {
  height: 200px;
  max-width: 100%;
  object-fit: contain;
}

/* Order */

.Callsheets_OrderBox__dujKT {
  background-color: rgb(209, 240, 240);
}

.Callsheets_InputBar__JstYA {
  background: #ffffff;
  border: 1px solid #e0e3eb;
  box-sizing: border-box;
  height: 30px !important;
  border-radius: 20px;
  color: #242a3d;
  padding-left: 40px;
  margin-bottom: 16px;
} 

@media screen and (max-width: 600px) {
  .Callsheets_Top__PyKCF {
  background-color: #1ea7ae;
  border: 5px solid #1ea7ae;
  color: #fff;
}

  .Callsheets_InputBar__JstYA {
    height: 20px !important;
    font-size: .75rem !important;
  }

  .Callsheets_Border2__Wmkl7 {
    min-height: 28px;
  }

  .Callsheets_SubTitleSpan__nHF1X {
    font-size: 1rem;
  }
  
  .Callsheets_BoldScene__c2Xij {
    font-size: .75rem;
  }

  .Callsheets_BoldScene2__MhZqN {
    font-size: .75rem;
  }

  .Callsheets_Input__mlVQP {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .Callsheets_InputB__XOf4R {
    height: 20px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .Callsheets_InputScene__gSA\\+0 {
    min-height: 30px !important;
    text-align: center;
    font-size: .75rem !important;
  }

  .Callsheets_Width__LMySo {
    width: 90%;
  }

  .Callsheets_Width2__dnvIB {
    width: 90%;
  }

  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 780px) {
  .Callsheets_CrewInfoP__XMxjk {
  font-weight: 700;
  margin-bottom: 3px;
  color: #212651;
}

.Callsheets_CrewInfop__Lp1Ha {
  margin-bottom: 3px;
  color: #212651;
}

  .Callsheets_BreakCrew__BWXoB {
    /* border-bottom: 5px solid #c1f1f7 ;
    border-top: 1px solid #fff ; */
    border-top: 2px solid #c1f1f7 ;
}

  hr {
    border-top: 1px solid #a3eaf7;
    border-top: 1px solid #c1f1f7;
  }

  .Callsheets_Width3__w2HdB {
    width: 50%;
  }

  .Callsheets_Width__LMySo {
    width: 90%;
  }

  .Callsheets_SubTitle2__q\\+6mW {
    width: 90%;
  }

  .Callsheets_SubTitle3__YAH9U {
    width: 90%;
  }

  .Callsheets_SubTitle4__Gqcdd {
    width: 90%;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/Callsheets.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;EACpC;;AAEF;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;CACC,+BAA+B;CAC/B,8BAA8B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;;;;;GAKG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;GAKG;;AAEH;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;gBACc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;mBACiB;EACjB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB;yBACuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;CACnB;;AAED;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;;GAEG;;AAEH;;;;;;;;;;GAUG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,SAAS;;AAET;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;EACA,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;EAEE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;EACA,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;EAEE;IACE;kCAC8B;IAC9B,8BAA8B;AAClC;;EAEE;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;AAEF","sourcesContent":[".Container {\n    min-height: 100px;\n}\n\n.SubTitleSpan {\n  background-color: #c1f1f7;\n  font-weight: 700;\n  /* font-size: 1.5rem; */\n}\n\n.Break5 {\n  border-top: 4px solid #c1f1f7;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Walk1 {\n  color: #000;\n  font-weight: 700;\n}\n\n.Walk2 {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 700;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.SubTitleC {\n  background-color: #39606e;\n  background-color: #e8f0f1;\n  /* background-color: #00d1ff; */\n  font-weight: 700;\n  /* color: #fff; */\n}\n\n.UsersInfo {\n  color: #1da3aa;\n}\n\n.Ital {\n  font-style: italic;\n}\n\n.ManTitle {\n color: #038dac;\n font-weight: 700;\n}\n\n.AddCrew {\n  color: #000;\n}\n\n.Small {\n  font-size: .75rem;\n  font-style: italic;\n}\n\n.SmallInfo {\n  font-size: .75rem;\n  color: #1da3aa;\n  color: #0c414f;\n  cursor: pointer;\n}\n\n.SmallSize {\n  font-size: .75rem;\n  color: #1da3aa;\n}\n\n.SmallSizeBold {\n  font-size: .85rem;\n  font-weight: 700;\n}\n\n.SmallCrew {\n  font-size: .85rem;\n  font-weight: 700;\n  color: #0c414f;\n  color: #0c5d73;\n}\n\n.Role {\n  color: #686c8a;\n  color: #525463;\n  color: #494d70;\n}\n\n.CountryBack {\n  background-color: #32c0e4;\n  color: #fff;\n}\n\n.BorderYour {\n  background-color: #f7e7f6;\n}\n\n.BorderbbbYour {\n  background-color: rgb(223 254 240);\n}\n\n.YourCallMed {\n  font-weight: 700;\n  color: #780770;\n  /* font-family: Playfair; */\n  /* font-size: 2.5rem; */\n  color: #076f78;\n  color: #000;\n}\n\n.YourCallMob {\n  /* background-color: #c1f1f7; */\n  color: #780770;\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: #076f78;\n  color: #000;\n}\n\n.YourCallMobUser {\n  background-color: #c1f1f7;\n  color: #000;\n  font-size: 1rem;\n  color: #076f78;\n}\n\n.UnitCallMed {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #076f78;\n}\n\n.UnitCallMob {\n  color: #076f78;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.UnitCallMedDate {\n  background-color: #e9fffd;\n  font-style: italic;\n  color: #000;\n  font-size: 1.25rem;\n}\n\n.UnitCallMedDate2 {\n  /* background-color: #e9fffd; */\n  font-style: italic;\n  color: #780770;\n  font-size: 1.5rem;\n}\n\n.UnitCallMobDate {\n  background-color: #e9fffd;\n  font-style: italic;\n  color: #000;\n  font-size: 1rem;\n}\n\n.UnitCallMedDay {\n  background-color: #f6fffe;\n  color: #000;\n  font-size: 1.25rem;\n}\n\n.UnitCallMobDay {\n  background-color: #f6fffe;\n  color: #000;\n  font-size: 1rem;\n}\n\n.CharactersTitle {\n  color: rgb(40, 189, 189);\n  color: rgba(89, 70, 14, 0.99);\n  font-weight: 600;\n}\n\n.Div30div {\n    height: 30px;\n    overflow: hidden;\n  }\n\n  .Div30div2 {\n    overflow: hidden;\n  }\n\n  .Div30A {\n    color: #666;\n    font-weight: 400;\n  }\n\n  .Div30M {\n    color: #333;\n    font-weight: 700;\n    /* font-size: .75rem !important; */\n  }\n\n.BorderRight {\n  border-right: 1px solid #c1f1f7;\n}\n\n.Hig20 {\n  min-height: 20px;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.BreakBlack {\n  border-top: 5px solid #000;\n}\n\n.BottomScene {\n  border-bottom: 3px solid #708386;\n}\n\n.Red {\n  color: #00d1ff;\n}\n\n.Red2 {\n  color: red;\n}\n\n.SubTitle6 {\n    background-color: #010f13;\n    color: #fff;\n    font-size: 1.25rem;\n    /* font-family: \"Noto Serif\"; */\n}\n\n.Border2 i {\n  color: #000;\n}\n\n.EditXcrew {\n  background-color: #fff;\n  border: 1px solid rgba(226, 200, 123, 0.99);\n}\n\n.SubTitle11 {\n  background-color: #fff;\n  font-weight: 700;\n  color: #000;\n  border: 3px solid red;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.WhiteEdit {\n  background-color: #fff;\n  border: 2px solid #c1f1f7;\n}\n\n.WhiteForm {\n  background-color: #fff;\n  border-left: 1px solid rgba(129, 102, 21, 0.99);\n  border-right: 1px solid rgba(129, 102, 21, 0.99);\n  border-bottom: 1px solid rgba(129, 102, 21, 0.99);\n  border-top: 1px solid rgba(129, 102, 21, 0.99);\n}\n\n.Break7 {\n  border-top: 3px solid #c1f1f7;\n}\n\n.RightPanel {\n border-right: 1px solid #c1f1f7;\n border-left: 1px solid #c1f1f7;\n}\n\n.CastCall {\n  border-top: 3px solid #c1f1f7;\n  border-bottom: 3px solid #c1f1f7;\n  border-left: 3px solid #c1f1f7;\n  border-right: 3px solid #c1f1f7;\n}\n/* .CastCall {\n  border-top: 2px solid #c1f1f7;\n  border-bottom: 2px solid #c1f1f7;\n  border-left: 2px solid #c1f1f7;\n  border-right: 2px solid #c1f1f7;\n} */\n\n.HrSched {\n  border-top: 2px solid #fff;\n}\n\n.Info {\n  font-size: .75rem !important;\n  font-weight: 700;\n  /* color: rgb(170, 27, 55); */\n  color: rgb(183, 44, 72);\n  cursor: pointer;\n  font-style: italic;\n}\n\n.Info:hover {\n  color: rgb(107, 10, 29);;\n}\n\n.SelectBox {\n  border: 1px solid #c1f1f7;\n}\n\n.BoldSceneS {\n  border-bottom: #1ea7ae;\n  width: 80%;\n}\n\n.HRWide {\n  border-top: 3px solid #c1f1f7;\n}\n\n.HRWider {\n  border-top: 10px solid #e8f0f1;\n}\n\n.HRGold2 {\n  border-top: 1px solid rgba(226, 200, 123, 0.99);\n  border-top: 1px solid #00d1ff;\n}\n\n.HRGold {\n  border-bottom: 1px solid rgba(226, 200, 123, 0.99);\n  min-height: 20px;\n}\n\n.Borderl {\n  padding-bottom: 5px;\n}\n\n.BreakCrew {\n  border-top : 2px solid #c1f1f7;\n}\n\n/* .Border {\n  border-top: 2px solid #e8f0f1;\n  border-bottom: 2px solid #e8f0f1;\n  border-left: 2px solid #e8f0f1;\n  border-right: 2px solid #e8f0f1;\n} */\n\n.Border {\n  border-top: 3px solid #c1f1f7;\n  border-bottom: 3px solid #c1f1f7;\n  border-left: 3px solid #c1f1f7;\n  border-right: 3px solid #c1f1f7;\n}\n\n.BorderLoc {\n  border-top: 1px solid #c1f1f7;\n  border-bottom: 1px solid #c1f1f7;\n  border-left: 1px solid #c1f1f7;\n  border-right: 1px solid #c1f1f7;\n}\n\n.Border2 {\n  border-top: 1px solid #c1f1f7;\n  border-bottom: 1px solid #c1f1f7;\n  border-left: 1px solid #c1f1f7;\n  border-right: 1px solid #c1f1f7;\n  min-height: 34px;\n}\n\n.Border3 {\n  border-bottom: 1px solid #c1f1f7;\n}\n\n.White1 {\n  border: 1px solid #999;\n}\n\n  .Width {\n    width: 70%;\n  }\n  \n  .Width2 {\n    width: 80%;\n  }\n  \n  .Width3 {\n    width: 80%;\n  }\n  \n  .Width95 {\n    width: 95%;\n  }\n\np {\n  margin-bottom: 0;\n}\n\n.SubTitleBlack{\n  background-color: #000;\n  color: #fff;\n  font-weight: 700;\n}\n\n.Break4 {\n  border-top: 5px solid #b1b5b6;\n}\n\n.SubTitle2 {\n  background-color: #d6fcff;;\n  font-weight: 700;\n  width: 40%;\n  color: rgba(129, 102, 21, 0.99);\n  color: #000\n}\n\n.SubTitle2 p {\n  color: #fff;\n} \n\n.SubTitle3 {\n  background-color: #e4f2f4;\n  font-weight: 700;\n  width: 20%;\n}\n\n.SubTitle4 {\n  background-color: #e4f2f4;\n  font-weight: 700;\n  width: 60%;\n}\n\n.SubTitle7 {\n  background-color: #e4f2f4;\n  font-weight: 700;\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.BoldScene2 {\n  color: rgba(129, 102, 21, 0.99);\n}\n\n.CrewInfoP {\n  font-weight: 700;\n  margin-bottom: 3px;\n  color: #616370;\n  color: #494d70;\n}\n\n.CrewInfop {\n  margin-bottom: 3px;\n  color: #616370;\n  color: #494d70;\n}\n\n.CrewInfop i {\n  margin-bottom: 3px;\n  color: #616370;\n  color: #494d70;\n}\n\n.Icon i {\n  color: #000;\n}\n\n.BoldTitleCall {\n  font-weight: 700;\n  color: #F5F5F5;\n  background-color: #000;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.Break1 {\n  border-top: 1px solid #d0d9db;\n  /* border-top: 1px solid rgb(140, 111, 25, 99%); */\n}\n\n.Break2 {\n  border-top: 5px solid #d0d9db;\n}\n\n/* CallsheetTop */\n.BoldBase {\n  color: #1ea7ae;\n}\n\n.Top {\n  background-color: #1ea7ae;\n  border: 3px solid #1ea7ae;\n  color: #fff;\n}\n\n.Top:hover {\n  background-color: #27c6cf;\n  color: #fff;\n}\n\n.Inner {\n  background-color: #fafafa;\n  color: #000;\n}\n\n.Top:hover .Inner {\n  background-color: #27c6cf;\n  color: fff;\n}\n\n.Map {\n  cursor: pointer;\n}\n\n.BodyColor {\n  background-color: #f8f8f8;\n  height: 40px;\n}\n\n.WhiteAqua {\n  background-color: #f6fffe;\n}\n\n.WhiteAquaPro {\n  background-color: #f6fffe;\n  font-family: Playball;\n}\n\n.WhiteAquaAdd {\n  background-color: #f6fffe;\n  font-family: Playfair;\n}\n\n.WhiteAquaAdd2 {\n  background-color: #f6fffe;\n  font-family: Playfair;\n}\n.WhiteAquaAdd3 {\n  background-color: #f6fffe;\n  font-family: Parisienne;\n}\n.WhiteAquaAdd4 {\n  background-color: #f6fffe;\n  font-family: Parisienne;\n}\n\n.Close {\n  color: rgb(28, 131, 131);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.Close:hover {\n  color: rgb(60, 237, 237);\n  cursor: pointer;\n}\n\n#dropdown-basic-button {\n  padding: 0.1rem 0.1rem;\n  color: #000;\n  background-color: #27c6cf;\n}\n\n.dropdown-menu {\n  overflow-y: scroll;\n}\n\n#dropdown-basic-button {\n  padding: 0.01rem 0.01rem !important;\n  color: #000;\n  background-color: #27c6cf;\n}\n\n.dropdown-menu {\n  display: block;\n  overflow-y: scroll !important\n}\n\n.DropButt {\n  /* z-index: 999;\n  color: #000; */\n  overflow-y: scroll;\n  height: 300px;\n}\n\n.dropdown-toggle.btn.btn-primary {\n  color: #000\n}\n\n.CloseIns {\n  color: red;\n}\n\n.Back {\n  background-color: rgb(242, 247, 252);\n}\n\n.Back2 {\n  background-color: #ffffff;\n}\n\n.Back3 {\n  background-color: rgb(241 248 253);\n}\n\n.Crew {\n  min-height: 50px;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.CallLogoDiv {\n  height: 80px;\n  border: 2px solid #456989;\n}\n\n.CallLogoDivMob {\n  height: 60px;\n  border: 2px solid #456989;\n}\n\n.UnitCall {\n  background-color: #c1f1f7;\n  color: #000;\n}\n\n.MovieName {\n  /* color: #00d1ff;\n  color: #780770; */\n  color: #000; \n  font-size: 2.5rem;\n  background-color: #f6fffe;\n  font-family: Playball;\n  /* padding-left: 120px;\n  padding-right: 120px; */\n  padding-top: 0px;\n  margin-top: 0px;\n}\n\n.MovieNameMo {\n  color: #00d1ff;\n  color: #780770;\n  color: #000;\n  font-size: 1.75rem;\n  background-color: #f6fffe;\n  font-family: Playball;\n}\n\n.LogoEdit {\n  height: 1px;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n.Logo {\n  height: 100px;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n.LogoMo {\n  height: 50px;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n.BoldU {\n  color: #780770;\n  font-weight: 700;\n}\n\n.BoldV {\n  color: #076f78;\n  font-weight: 700;\n}\n\n.BoldA {\n  color: #076f78;\n  font-weight: 700;\n}\n\n.WhiteAquaProU {\n  background-color: #f6fffe;\n  font-family: Playball;\n  color: #076f78;\n}\n\n.Titles {\n  background-color: #dbf2f5;\n  color: #000;\n}\n\n.CrewInfoRow {\n  /* border-bottom: 5px solid #fff; */\n  /* border-top: 5px solid #fff; */\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.CrewInfoRowAdd {\n  border-bottom: 1px solid #fff;\n}\n\n/* .Button {\n  color: #185f70;\n  font-weight: 700;\n  cursor: pointer;\n} */\n\n.Button {\n  color: #013441;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.Button:hover {\n  color: #04809f;\n  font-weight: 700;\n}\n\n.AcknowledgeButton {\n  min-width: 9rem;\n  width: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n  white-space: nowrap;\n}\n\n.Important {\n  background-color: antiquewhite;\n}\n\n.ImportantText {\n  color: #000;\n}\n\n.CastEntered {\n  background-color: #dde7ef;\n  background-color: #f1f5f7;\n  background-color: #ecfbfd;\n  min-height: 40px;\n}\n\n.Bold { \n  font-weight: 700;\n}\n\n.Title {\n  background-color: #fff;\n}\n\n.Input {\n  background: #ffffff;\n  /* border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  text-align: center;\n  height: 30px !important;\n}\n\n.InputB {\n  background: #ffffff;\n  /* border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  height: 30px !important;\n}\n\n.InputScene {\n  background: #ffffff;\n  /* border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #525463;\n  padding: 0px 10px;\n  min-height: 30px !important;\n  text-align: center;\n }\n\n.TitleBox {\n  background-color: #e8f0f1;\n  color: #333;\n}\n\n.TitleBoxB {\n  font-weight: 700;\n}\n\n.TitleBox2 {\n  border-right : 2px solid #fff;\n  color: #000;\n}\n\n/* .Border2 {\n  border: 2px solid #e8f0f1;\n} */\n\n/* .Borderl {\n  border-bottom: 2px solid #e8f0f1;\n  border-left: 2px solid #e8f0f1;\n  border-right: 2px solid #e8f0f1;\n}\n\n.Borderm {\n  border-bottom: 2px solid #e8f0f1;\n  border-left: 2px solid #e8f0f1;\n  border-right: 2px solid #e8f0f1;\n} */\n\n.HSpan {\n  font-size: .75rem;\n  font-weight: 700;\n}\n\n.FormBox {\n  background-color: aliceblue;\n  font-weight: 700;\n}\n\n.ScenesBox {\n  background-color: #eaf2fa;\n}\n\n.NextCall {\n  background-color: #fffff5; \n  color: #000;\n}\n\n.Drop i {\n  color: #000;\n}\n\n/* info */\n\n.SceneBox {\n  border: 1px solid #fafafa;\n  background-color: #fff;\n  font-weight: 700;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: rgb(209, 240, 240);\n}\n\n.Image {\n  height: 200px;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n/* Order */\n\n.OrderBox {\n  background-color: rgb(209, 240, 240);\n}\n\n.InputBar {\n  background: #ffffff;\n  border: 1px solid #e0e3eb;\n  box-sizing: border-box;\n  height: 30px !important;\n  border-radius: 20px;\n  color: #242a3d;\n  padding-left: 40px;\n  margin-bottom: 16px;\n} \n\n@media screen and (max-width: 600px) {\n  .Top {\n  background-color: #1ea7ae;\n  border: 5px solid #1ea7ae;\n  color: #fff;\n}\n\n  .InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n  }\n\n  .Border2 {\n    min-height: 28px;\n  }\n\n  .SubTitleSpan {\n    font-size: 1rem;\n  }\n  \n  .BoldScene {\n    font-size: .75rem;\n  }\n\n  .BoldScene2 {\n    font-size: .75rem;\n  }\n\n  .Input {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputB {\n    height: 20px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .InputScene {\n    min-height: 30px !important;\n    text-align: center;\n    font-size: .75rem !important;\n  }\n\n  .Width {\n    width: 90%;\n  }\n\n  .Width2 {\n    width: 90%;\n  }\n\n  h1 {\n    font-size: 1.75rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n  }\n}\n\n@media screen and (max-width: 780px) {\n  .CrewInfoP {\n  font-weight: 700;\n  margin-bottom: 3px;\n  color: #212651;\n}\n\n.CrewInfop {\n  margin-bottom: 3px;\n  color: #212651;\n}\n\n  .BreakCrew {\n    /* border-bottom: 5px solid #c1f1f7 ;\n    border-top: 1px solid #fff ; */\n    border-top: 2px solid #c1f1f7 ;\n}\n\n  hr {\n    border-top: 1px solid #a3eaf7;\n    border-top: 1px solid #c1f1f7;\n  }\n\n  .Width3 {\n    width: 50%;\n  }\n\n  .Width {\n    width: 90%;\n  }\n\n  .SubTitle2 {\n    width: 90%;\n  }\n\n  .SubTitle3 {\n    width: 90%;\n  }\n\n  .SubTitle4 {\n    width: 90%;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Callsheets_Container__ukv-Z`,
	"SubTitleSpan": `Callsheets_SubTitleSpan__nHF1X`,
	"Break5": `Callsheets_Break5__tYV0s`,
	"BreakTitle": `Callsheets_BreakTitle__zoSqI`,
	"Walk1": `Callsheets_Walk1__iZdce`,
	"Walk2": `Callsheets_Walk2__yNZgy`,
	"SubTitle": `Callsheets_SubTitle__BB2uj`,
	"SubTitleC": `Callsheets_SubTitleC__qMd7Z`,
	"UsersInfo": `Callsheets_UsersInfo__O1rXx`,
	"Ital": `Callsheets_Ital__eUzSj`,
	"ManTitle": `Callsheets_ManTitle__K6Aqm`,
	"AddCrew": `Callsheets_AddCrew__c5MNV`,
	"Small": `Callsheets_Small__ZWuZz`,
	"SmallInfo": `Callsheets_SmallInfo__XiCw0`,
	"SmallSize": `Callsheets_SmallSize__FzpMg`,
	"SmallSizeBold": `Callsheets_SmallSizeBold__iX30k`,
	"SmallCrew": `Callsheets_SmallCrew__PLa5W`,
	"Role": `Callsheets_Role__Rp82f`,
	"CountryBack": `Callsheets_CountryBack__yX+Yz`,
	"BorderYour": `Callsheets_BorderYour__HXjS0`,
	"BorderbbbYour": `Callsheets_BorderbbbYour__tKDO8`,
	"YourCallMed": `Callsheets_YourCallMed__1vAza`,
	"YourCallMob": `Callsheets_YourCallMob__MxlgX`,
	"YourCallMobUser": `Callsheets_YourCallMobUser__IXWrj`,
	"UnitCallMed": `Callsheets_UnitCallMed__FwDJO`,
	"UnitCallMob": `Callsheets_UnitCallMob__ErYpV`,
	"UnitCallMedDate": `Callsheets_UnitCallMedDate__yF1Td`,
	"UnitCallMedDate2": `Callsheets_UnitCallMedDate2__v+FBW`,
	"UnitCallMobDate": `Callsheets_UnitCallMobDate__Tl-v7`,
	"UnitCallMedDay": `Callsheets_UnitCallMedDay__mswjn`,
	"UnitCallMobDay": `Callsheets_UnitCallMobDay__tZskQ`,
	"CharactersTitle": `Callsheets_CharactersTitle__Fg+rw`,
	"Div30div": `Callsheets_Div30div__a8muN`,
	"Div30div2": `Callsheets_Div30div2__P4RB-`,
	"Div30A": `Callsheets_Div30A__EyG6z`,
	"Div30M": `Callsheets_Div30M__qpOjs`,
	"BorderRight": `Callsheets_BorderRight__z9+Th`,
	"Hig20": `Callsheets_Hig20__774NH`,
	"Break": `Callsheets_Break__MaUdb`,
	"BreakBlack": `Callsheets_BreakBlack__-xzG-`,
	"BottomScene": `Callsheets_BottomScene__FLTk5`,
	"Red": `Callsheets_Red__yKFeJ`,
	"Red2": `Callsheets_Red2__xfBJL`,
	"SubTitle6": `Callsheets_SubTitle6__EbztF`,
	"Border2": `Callsheets_Border2__Wmkl7`,
	"EditXcrew": `Callsheets_EditXcrew__YEtKW`,
	"SubTitle11": `Callsheets_SubTitle11__bXUuS`,
	"White": `Callsheets_White__BaLoQ`,
	"WhiteEdit": `Callsheets_WhiteEdit__be7bC`,
	"WhiteForm": `Callsheets_WhiteForm__bBrok`,
	"Break7": `Callsheets_Break7__PRssg`,
	"RightPanel": `Callsheets_RightPanel__g4Mr4`,
	"CastCall": `Callsheets_CastCall__+ZLY0`,
	"HrSched": `Callsheets_HrSched__v9+el`,
	"Info": `Callsheets_Info__tNKN2`,
	"SelectBox": `Callsheets_SelectBox__BAlUd`,
	"BoldSceneS": `Callsheets_BoldSceneS__pCQSs`,
	"HRWide": `Callsheets_HRWide__9PBtK`,
	"HRWider": `Callsheets_HRWider__+Gp8D`,
	"HRGold2": `Callsheets_HRGold2__v0Gn6`,
	"HRGold": `Callsheets_HRGold__Sh+no`,
	"Borderl": `Callsheets_Borderl__mMXk7`,
	"BreakCrew": `Callsheets_BreakCrew__BWXoB`,
	"Border": `Callsheets_Border__tKCn7`,
	"BorderLoc": `Callsheets_BorderLoc__DPX0c`,
	"Border3": `Callsheets_Border3__c4i1O`,
	"White1": `Callsheets_White1__6VR1t`,
	"Width": `Callsheets_Width__LMySo`,
	"Width2": `Callsheets_Width2__dnvIB`,
	"Width3": `Callsheets_Width3__w2HdB`,
	"Width95": `Callsheets_Width95__y+5K3`,
	"SubTitleBlack": `Callsheets_SubTitleBlack__Wihw4`,
	"Break4": `Callsheets_Break4__6OU7H`,
	"SubTitle2": `Callsheets_SubTitle2__q+6mW`,
	"SubTitle3": `Callsheets_SubTitle3__YAH9U`,
	"SubTitle4": `Callsheets_SubTitle4__Gqcdd`,
	"SubTitle7": `Callsheets_SubTitle7__x6Kli`,
	"BoldScene": `Callsheets_BoldScene__c2Xij`,
	"BoldScene2": `Callsheets_BoldScene2__MhZqN`,
	"CrewInfoP": `Callsheets_CrewInfoP__XMxjk`,
	"CrewInfop": `Callsheets_CrewInfop__Lp1Ha`,
	"Icon": `Callsheets_Icon__ELQb+`,
	"BoldTitleCall": `Callsheets_BoldTitleCall__l+GYS`,
	"Break1": `Callsheets_Break1__QbNzP`,
	"Break2": `Callsheets_Break2__WBt5x`,
	"BoldBase": `Callsheets_BoldBase__J23K9`,
	"Top": `Callsheets_Top__PyKCF`,
	"Inner": `Callsheets_Inner__nniYk`,
	"Map": `Callsheets_Map__P9aTA`,
	"BodyColor": `Callsheets_BodyColor__BOS6f`,
	"WhiteAqua": `Callsheets_WhiteAqua__KQeEo`,
	"WhiteAquaPro": `Callsheets_WhiteAquaPro__wDcQB`,
	"WhiteAquaAdd": `Callsheets_WhiteAquaAdd__1aV5P`,
	"WhiteAquaAdd2": `Callsheets_WhiteAquaAdd2__pHaX6`,
	"WhiteAquaAdd3": `Callsheets_WhiteAquaAdd3__12wNw`,
	"WhiteAquaAdd4": `Callsheets_WhiteAquaAdd4__GMNSz`,
	"Close": `Callsheets_Close__iMoch`,
	"dropdown-basic-button": `Callsheets_dropdown-basic-button__XWdxb`,
	"dropdown-menu": `Callsheets_dropdown-menu__vmrS-`,
	"DropButt": `Callsheets_DropButt__zfEWp`,
	"dropdown-toggle": `Callsheets_dropdown-toggle__c6Kks`,
	"btn": `Callsheets_btn__NE8wM`,
	"btn-primary": `Callsheets_btn-primary__HoX9F`,
	"CloseIns": `Callsheets_CloseIns__iiNS3`,
	"Back": `Callsheets_Back__B6sSU`,
	"Back2": `Callsheets_Back2__ypRTo`,
	"Back3": `Callsheets_Back3__RKwvq`,
	"Crew": `Callsheets_Crew__YrTRi`,
	"CallLogoDiv": `Callsheets_CallLogoDiv__CpUjk`,
	"CallLogoDivMob": `Callsheets_CallLogoDivMob__2npdA`,
	"UnitCall": `Callsheets_UnitCall__7l8Z0`,
	"MovieName": `Callsheets_MovieName__1tijB`,
	"MovieNameMo": `Callsheets_MovieNameMo__xGt2j`,
	"LogoEdit": `Callsheets_LogoEdit__3Gh6B`,
	"Logo": `Callsheets_Logo__1WmoB`,
	"LogoMo": `Callsheets_LogoMo__2FAqW`,
	"BoldU": `Callsheets_BoldU__Ylogb`,
	"BoldV": `Callsheets_BoldV__RWZDZ`,
	"BoldA": `Callsheets_BoldA__Ss+W5`,
	"WhiteAquaProU": `Callsheets_WhiteAquaProU__BRoNH`,
	"Titles": `Callsheets_Titles__dEGbn`,
	"CrewInfoRow": `Callsheets_CrewInfoRow__m2T-x`,
	"CrewInfoRowAdd": `Callsheets_CrewInfoRowAdd__fBkFW`,
	"Button": `Callsheets_Button__qVsj3`,
	"AcknowledgeButton": `Callsheets_AcknowledgeButton__J+ESN`,
	"Important": `Callsheets_Important__mk7pa`,
	"ImportantText": `Callsheets_ImportantText__830I2`,
	"CastEntered": `Callsheets_CastEntered__pX8Wj`,
	"Bold": `Callsheets_Bold__-j0xc`,
	"Title": `Callsheets_Title__tudB+`,
	"Input": `Callsheets_Input__mlVQP`,
	"InputB": `Callsheets_InputB__XOf4R`,
	"InputScene": `Callsheets_InputScene__gSA+0`,
	"TitleBox": `Callsheets_TitleBox__w5RwR`,
	"TitleBoxB": `Callsheets_TitleBoxB__-18ag`,
	"TitleBox2": `Callsheets_TitleBox2__aVf9C`,
	"HSpan": `Callsheets_HSpan__oRPOR`,
	"FormBox": `Callsheets_FormBox__6evPI`,
	"ScenesBox": `Callsheets_ScenesBox__3y+0l`,
	"NextCall": `Callsheets_NextCall__tSkbc`,
	"Drop": `Callsheets_Drop__B9MIS`,
	"SceneBox": `Callsheets_SceneBox__aRZIv`,
	"BoldTitle": `Callsheets_BoldTitle__dTrtj`,
	"Image": `Callsheets_Image__BkUc3`,
	"OrderBox": `Callsheets_OrderBox__dujKT`,
	"InputBar": `Callsheets_InputBar__JstYA`
};
export default ___CSS_LOADER_EXPORT___;
